// 47284: red = Data Refreshes jobs in error, amber = stale / overdue / dependency-warning jobs. Hidden at 0; the tooltip lists the jobs.
// Same pill as the other nav badges (LeftMenu .badge / ModuleBar .mbadge, e.g. Alerts / Benchmarks red), amber = the Data Health .warn colours.
import React from 'react';
import { useTranslation } from 'react-i18next';

const RED = { background: 'var(--st-crit-bg)', color: 'var(--st-crit)', border: '1px solid color-mix(in srgb, var(--st-crit-dot) 30%, var(--surface))' };
const AMBER = { background: 'var(--st-warn-bg)', color: 'var(--st-warn)', border: '1px solid color-mix(in srgb, var(--st-warn-dot) 30%, var(--surface))' };

export default function RefreshHealthBadge({ health, cls = 'badge' }) {
  const { t } = useTranslation('common');
  if (!health) return null;
  const tip = (n, jobs, key) => (n > 0 ? [t(key, { count: n }), ...(jobs || []).map(j => `- ${j.label}`)].join('\n') : '');
  return (
    <>
      {health.error > 0 && <span className={cls} data-testid="refresh-badge-error" style={RED} title={tip(health.error, health.error_jobs, 'chromeUi.refreshErr')}>{health.error}</span>}
      {health.warn > 0 && <span className={cls} data-testid="refresh-badge-warn" style={{ ...AMBER, marginLeft: health.error > 0 ? 4 : undefined }} title={tip(health.warn, health.warn_jobs, 'chromeUi.refreshWarn')}>{health.warn}</span>}
    </>
  );
}
